import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { toast } from "react-toastify";
import AddUserModal from "./UserModal";

const Usuarios = () => {
  document.title = "Usuários | Dashboard";

  const [usuarios, setUsuarios] = useState([]);
  const [data, setData] = useState({
    columns: [
      { label: "Nome", field: "nome", sort: "asc", width: 150 },
      { label: "Telefone", field: "telefone", sort: "asc", width: 150 },
      { label: "Email", field: "email", sort: "asc", width: 150 },
      { label: "Ações", field: "acoes", sort: "asc", width: 100 },
    ],
    rows: [],
  });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [usuarioEditavel, setUsuarioEditavel] = useState(null);

  useEffect(() => {
    getUsuarios(page, search);
  }, [page, search]);

  const getUsuarios = (page, search) => {
    fetch(
      `${process.env.REACT_APP_API}/usuarios?page=${page}&limit=10&search=${search}`
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        setUsuarios(response.data);
        setTotalPages(response.pagination.totalPages);

        setData((prevState) => ({
          ...prevState,
          rows: response.data.map((usuario) => ({
            nome: usuario.nome,
            telefone: usuario.telefone,
            email: usuario.email,
            acoes: (
              <div>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    setUsuarioEditavel(usuario);
                    setModalOpen(true);
                  }}
                >
                  Editar
                </Button>
              </div>
            ),
          })),
        }));
      })
      .catch((error) => console.error("Erro ao buscar usuários:", error));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <React.Fragment>
      <AddUserModal
        isOpen={modalOpen}
        toggle={() => {
          setModalOpen(!modalOpen);
          setUsuarioEditavel(null);
        }}
        onUsuarioAdicionado={(message, type) => {
          toast(message, { type });
          getUsuarios(page, search);
        }}
        usuarioEditavel={usuarioEditavel}
      />

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={6}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por nome"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Button
                    color="primary"
                    onClick={() => setModalOpen(true)}
                    className="mr-2"
                  >
                    Adicionar Usuário
                  </Button>
                </Col>
              </Row>
              {usuarios?.length > 0 && (
                <MDBDataTable striped responsive bordered data={data} />
              )}
              <div className="d-flex justify-content-between">
                <Button
                  color="primary"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page <= 1}
                >
                  Anterior
                </Button>
                <span>
                  Página {page} de {totalPages}
                </span>
                <Button
                  color="primary"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= totalPages}
                >
                  Próxima
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Usuarios;
